import { UserType } from '@avanta/shared/constants/users';
import {
  chatReportSteps,
  psychologistReportSteps,
  StepComponentTypes,
} from 'constants/chat-report';
import { type StepType, type NestedOption } from 'types/chat-report';

export const ETIOLOGIES = {
  PERSONAL: 'PERSONAL',
  PROFESSIONAL: 'PROFESSIONAL',
  MIXED: 'MIXED',
} as const;

export const PERSONAL_DISORDERS = [
  'PATHOLOGY_ANXIETY',
  'PATHOLOGY_DEPRESSION',
  'PATHOLOGY_DUEL',
  'PATHOLOGY_SELF_ESTEEM',
  'PATHOLOGY_COUPLE',
  'PATHOLOGY_FAMILY',
  'PATHOLOGY_VITAL_CRISIS',
  'PATHOLOGY_INFIDELITY',
  'PATHOLOGY_SEXUALITY',
  'PATHOLOGY_EMOCIONAL_DEPENDENCY',
  'PATHOLOGY_FOOD',
  'PATHOLOGY_ADDICTION',
  'PATHOLOGY_DRUGS',
  'PATHOLOGY_ALCOHOL',
  'PATHOLOGY_GAMBLER',
  'PATHOLOGY_IRA',
  'PATHOLOGY_PERSONAL_DEVELOPMENT',
  'PATHOLOGY_SELF_KNOWLEDGE',
  'PATHOLOGY_TRAUMA',
  'PATHOLOGY_PHOBIAS',
  'PATHOLOGY_INSOMNIA',
  'PATHOLOGY_DYSFUNCTION',
  'PATHOLOGY_PARAPHILIA',
  'PATHOLOGY_SEXUAL_ORIENTATION',
  'PATHOLOGY_TEENAGER',
  'PATHOLOGY_PSICONUTRITION',
  'PATHOLOGY_SOCIAL_SKILLS',
  'PATHOLOGY_EMOTIONAL_INTELIGENCE',
  'PATHOLOGY_CHANGE_OF_HABITS',
  'PATHOLOGY_MOTIVATION',
  'PATHOLOGY_PERSONALITY',
  'PATHOLOGY_THIRD_AGE',
  'PATHOLOGY_LIFE_QUALITY',
  'PATHOLOGY_DYSLEXIA',
  'PATHOLOGY_LEARNING_DIFFICULTIES',
  'PATHOLOGY_CAREGIVER_SYNDROME',
  'PATHOLOGY_JURIDIC',
  'PATHOLOGY_LGTBIQA',
  'PATHOLOGY_GENDER_VIOLENCE',
  'PATHOLOGY_OBSESSIVE_COMPULSIVE_DISORDER',
  'PATHOLOGY_SUICIDAL_IDEATION',
  'PATHOLOGY_EATING_DISORDERS',
  'PATHOLOGY_SLEEP_DISORDERS',
  'PATHOLOGY_TRAUMATIC_EXPERIENCES_AND_ABUSE',
  'PATHOLOGY_NATURAL_DISASTERS_OR_ACCIDENTS',
] as const;

export const PROFESSIONAL_DISORDERS = [
  'PATHOLOGY_JOB',
  'PATHOLOGY_UNEMPLOYMENT',
  'PATHOLOGY_COACHING',
  'PATHOLOGY_SPORT',
  'PATHOLOGY_CONFLICT_MANAGEMENT',
  'PSYCHOSOCIAL_WORKLOAD',
  'PSYCHOSOCIAL_PSYCHOLOGICAL_DEMANDS',
  'PSYCHOSOCIAL_ROLE_PERFORMANCE_AND_JOB_INSECURITY',
  'PSYCHOSOCIAL_WORKER_INTEREST_AND_COMPENSATION',
  'PSYCHOSOCIAL_PARTICIPATION_AND_SUPERVISION',
  'PSYCHOSOCIAL_RELATIONSHIPS_AND_SOCIAL_SUPPORT',
  'PSYCHOSOCIAL_VARIETY_AND_JOB_CONTENT',
] as const;

export const MIXED_DISORDERS = [
  'PATHOLOGY_LEARNING',
  'PATHOLOGY_ILLNESS',
  'PATHOLOGY_CHILDS',
  'PATHOLOGY_STRESS',
  'PATHOLOGY_BULLYING',
] as const;

export const ISSUES = {
  APP_SUPPORT: 'APP_SUPPORT',
  THERAPY_SUPPORT: 'THERAPY_SUPPORT',
  REFUNDS_COMPLAINS: 'REFUNDS_COMPLAINS',
  APP_FUNCTIONAL_QUESTIONS: 'APP_FUNCTIONAL_QUESTIONS',
  NO_RESPONSE: 'NO_RESPONSE',
} as const;

const DISORDERS: NestedOption = {
  [ETIOLOGIES.PERSONAL]: PERSONAL_DISORDERS,
  [ETIOLOGIES.PROFESSIONAL]: PROFESSIONAL_DISORDERS,
  [ETIOLOGIES.MIXED]: MIXED_DISORDERS,
} as const;

export const LAST_STEP_ISSUES = [ISSUES.NO_RESPONSE, ISSUES.APP_FUNCTIONAL_QUESTIONS];

export const steps: Record<UserType.PSYCHOLOGIST, StepType[]> = {
  [UserType.PSYCHOLOGIST]: [
    {
      id: 1,
      name: chatReportSteps.issueType,
      options: {
        [ISSUES.THERAPY_SUPPORT]: ISSUES.THERAPY_SUPPORT,
        [ISSUES.APP_FUNCTIONAL_QUESTIONS]: ISSUES.APP_FUNCTIONAL_QUESTIONS,
        [ISSUES.NO_RESPONSE]: ISSUES.NO_RESPONSE,
      },
      component: StepComponentTypes.radio,
    },
    {
      id: 2,
      name: psychologistReportSteps.etiologyProblem,
      options: ETIOLOGIES,
      component: StepComponentTypes.radio,
    },
    {
      id: 3,
      name: psychologistReportSteps.disorders,
      options: DISORDERS,
      component: StepComponentTypes.checkbox,
    },
    {
      id: 4,
      name: psychologistReportSteps.reportObservations,
      component: StepComponentTypes.textarea,
    },
  ],
};
